<template>
  <div class="shop">
    <el-button
      size="small"
      style="float:right;margin-bottom:20px"
      type="primary"
      @click="addItem"
      >添加</el-button
    >
    <el-table
      :data="tableData"
      max-height="720"
      :cell-style="tc"
      :header-cell-style="tccolor"
    >
      <el-table-column label="序号" prop="id"></el-table-column>
      <el-table-column label="活动名称" prop="name"></el-table-column>
      <el-table-column label="活动链接" prop="activity_url"></el-table-column>
      <el-table-column label="操作" fixed="right" width="200">
        <template slot-scope="scope">
          <el-button size="mini" @click="editItem(scope.row)">编辑</el-button>
          <el-button
            size="mini"
            type="primary"
            @click="deleteItem(scope.row)"
            >删除</el-button
          >
        </template>
      </el-table-column>
    </el-table>
    <el-col :span="24">
      <div class="pagination">
        <el-pagination
          background
          @current-change="pageChange"
          :current-page="form.page"
          :page-size="form.size"
          layout="total, prev, pager, next, jumper"
          :total="total"
        ></el-pagination>
      </div>
    </el-col>
    <!--添加弹窗-->
    <jdialog title="添加活动" :visible.sync="isShowAddWindow" width="640px">
      <el-form :model="addWindowInfo" ref="ruleForm" class="demo-ruleForm" label-width="80px">
        <el-form-item label="活动名称">
          <el-input
            type="text"
            placeholder="活动名称"
            v-model="addWindowInfo.name"
          ></el-input>
        </el-form-item>
        <el-form-item label="活动链接">
          <el-input
            type="text"
            placeholder="活动链接"
            v-model="addWindowInfo.url"
          ></el-input>
        </el-form-item>
      </el-form>

      <div class="align">
        <el-button size="mini" @click="isShowAddWindow = false">取消</el-button>
        <el-button size="mini" type="primary" @click="creatAdd">确定</el-button>
      </div>
    </jdialog>
    <!--编辑弹窗-->
    <jdialog title="编辑活动" :visible.sync="isShowEditWindow" width="640px">
      <el-form :model="windowInfo" ref="ruleForm" class="demo-ruleForm" label-width="80px">
        <el-form-item label="活动名称">
          <el-input
            type="text"
            placeholder="活动名称"
            v-model="windowInfo.name"
          ></el-input>
        </el-form-item>
        <el-form-item label="活动链接">
          <el-input
            type="text"
            placeholder="活动链接"
            v-model="windowInfo.url"
          ></el-input>
        </el-form-item>
      </el-form>

      <div class="align">
        <el-button size="mini" @click="isShowEditWindow = false"
          >取消</el-button
        >
        <el-button size="mini" type="primary" @click="creatEdit"
          >确定</el-button
        >
      </div>
    </jdialog>
    <!-- 删除弹窗 -->
     <el-dialog
      :visible.sync="isShowDeletetWindow"
      width="30%"
      center>
      <span>是否确认删除</span>
      <span slot="footer" class="dialog-footer">
        <el-button @click="isShowDeletetWindow = false">取 消</el-button>
        <el-button type="primary" @click="creatDel">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
// import uploadImg from "@/components/uploadImg";
import { getActivityList, activityAddEdit, activityDelete } from '@/api/activity'
export default {
  components: {},
  data() {
    return {
      tableData: [],
      labelPosition: 'right',
      isShowAddWindow: false,
      isShowEditWindow: false,
      isShowDeletetWindow: false,
      deleteInfo: {},
      form: {
        page: 1
      },
      total: 0,
      addWindowInfo: {
        name: '',
        url: ''
      },
      windowInfo: {
        id: '',
        name: '',
        url: ''
      }
    }
  },
  mounted() {
    this.getActivityList()
  },
  methods: {
    //获取列表数据
    async getActivityList() {
      let url = `page=${this.form.page}`
      let res = await getActivityList(url)
      console.log(res)
      if (res.code === 10000) {
        this.tableData = res.data.data
        this.total = res.data.total
      } else {
        this.$message.error(res.message)
      }
    },

    // 删除
    deleteItem(info) {
      this.isShowDeletetWindow = true
      this.deleteInfo = info
    },
    //显示添加弹窗
    addItem() {
      this.addWindowInfo.url = ''
      this.addWindowInfo.name = ''
      this.isShowAddWindow = true
    },
    //显示编辑弹窗
    editItem(info) {
      this.windowInfo.id = info.id
      this.windowInfo.url = info.activity_url
      this.windowInfo.name = info.name
      this.isShowEditWindow = true
    },
    //确认添加
    async creatAdd() {
      let name = this.addWindowInfo.name
      let activity_url = this.addWindowInfo.url
      let res = await activityAddEdit({
        name: name,
        activity_url: activity_url
      })
      if (res.code === 10000) {
        this.getActivityList()
        this.$message.success(res.message)
        this.isShowAddWindow = false
      } else {
        this.$message.error(res.message)
      }
    },
    //确认编辑。
    async creatEdit() {
      let id = this.windowInfo.id
      let name = this.windowInfo.name
      let activity_url = this.windowInfo.url
      let res = await activityAddEdit({
        id: id,
        name: name,
        activity_url: activity_url
      })
      if (res.code === 10000) {
        // this.windowInfo = res.data
        this.getActivityList()
        this.isShowEditWindow = false
        this.$message.success(res.message)
      } else {
        this.$message.error(res.message)
      }
    },
    // 确认删除。
    async creatDel() {
      let id = this.deleteInfo.id
      let res = await activityDelete({
        id: id
      })
      if (res.code === 10000) {
        this.getActivityList()
        this.isShowDeletetWindow = false
        this.$message.success(res.message)
      } else {
        this.$message.error(res.message)
      }
    },
    // 分页设置。
    pageChange(page) {
      this.form.page = page
      //获取更多数据
      this.getActivityList()
    },
    tc() {
      return 'text-align:center; color:#333333; font-size:12px;'
    },
    tccolor() {
      return 'text-align:center;background-color:#f5f5f5; font-size:14px;'
    }
  }
}
</script>
<style lang="scss" scoped>
.shop {
  padding: 20px;
  .pagination {
    float: right;
    margin-top: 12px;
  }
  .align {
    text-align: center;
    padding-bottom: 20px;
  }
  .demo-ruleForm {
    padding: 20px;
    .remarkarea {
      padding-right: 30px;
      margin-top: 20px;
    }
  }
}
</style>
